import React, { useState } from 'react';
import { ChevronArrowIcon } from './Icons';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../lib/metaPixel';
const BONUS_PREVIEWS = [{
  number: '1',
  title: 'Hormones in the Kitchen',
  subtitle: '30 Recipes',
  image: 'https://cdn.magicpatterns.com/uploads/uKc5KSk24JK85gw42GDamK/MOCKUT_BONUS_1_Hormones-in-the-Kitchen-30-Recipes-That-Work-With-Your-Body.png'
}, {
  number: '2',
  title: 'Smart Supplementation',
  subtitle: 'The Bible',
  image: 'https://cdn.magicpatterns.com/uploads/8Wy4xEbUqrf3jXppB6omB4/MOCKUT_BONUS_2_The-Smart-Supplementation-Bible.png'
}, {
  number: '3',
  title: 'Transformation Journal',
  subtitle: 'Progress Tracker',
  image: 'https://cdn.magicpatterns.com/uploads/nWEPumsCxqdQZmujZuM5Ak/MOCKUT_BONUS_3_My-Transformation-Journal.png'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Does it work if I am on birth control?',
    a: 'Yes. The protocol supports the liver and gut, which are the organs that work hardest when using hormonal contraceptives. It is complementary, not contradictory.'
  }, {
    q: 'When will I see results?',
    a: 'Most women notice changes in energy and digestion within the first 7-14 days. Cycle changes take 1-3 complete cycles.'
  }, {
    q: 'Do I need to buy expensive supplements?',
    a: 'No. The method is food-first by design. Supplements are optional and only recommended when a specific deficiency is present.'
  }, {
    q: "Does it work if I have PCOS or Hashimoto's?",
    a: 'The protocol can be very complementary. However, for diagnosed conditions, it is recommended to work alongside a functional health professional.'
  }, {
    q: 'How much time do I need each day?',
    a: 'Between 15 and 30 minutes. It is designed for women with real lives and busy schedules.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-light py-8 md:py-12 px-4 md:px-6" data-id="element-25">
      <div className="max-w-[780px] mx-auto" data-id="element-26">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-3" data-id="element-27">
          Frequently Asked Questions
        </h2>

        <p className="font-lato text-[16px] md:text-[18px] text-[#777777] text-center mb-6" data-id="element-28">
          Everything you need to know before getting started
        </p>

        <div className="flex flex-col gap-3" data-id="element-29">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-accent rounded-[10px] overflow-hidden" data-id="element-30">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-5 md:py-5 md:px-6 text-left focus:outline-none" data-id="element-31">
                <span className="font-lato font-bold text-[15px] md:text-[16px] text-body pr-4" data-id="element-32">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-33">
                  <ChevronArrowIcon color="#957DAD" size={20} data-id="element-34" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-35">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-36">
                    <div className="px-5 md:px-6 pb-5 pt-0 border-t border-[#F0EBF8] mt-2" data-id="element-37">
                      <p className="font-lato text-[15px] text-secondary leading-[1.7] m-0 pt-4" data-id="element-38">
                        {faq.a}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        {/* Secondary CTA */}
        <div id="final-cta" className="mx-auto text-center scroll-mt-16" style={{
        background: 'transparent',
        border: '2px solid #957DAD',
        borderRadius: '16px',
        padding: '40px 24px',
        maxWidth: '640px',
        margin: '48px auto 0 auto'
      }} data-id="element-39">
          <h3 className="font-playfair text-primary" style={{
          fontSize: '28px',
          marginBottom: '20px'
        }} data-id="element-40">
            Ready to feel like yourself again?
          </h3>

          <a href="https://vitalyforms.com/cart/50255656976604:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
          content_name: 'The Hormonal Balance Code — Secondary CTA'
        })} className="font-lato font-bold uppercase text-white inline-block mx-auto hover:bg-primary transition-colors duration-300 no-underline" style={{
          background: '#957DAD',
          fontSize: '16px',
          padding: '18px 40px',
          borderRadius: '50px',
          boxShadow: '0 6px 20px rgba(149,125,173,0.35)'
        }} data-id="element-41">
            GET INSTANT ACCESS — $27
          </a>

          <p className="font-lato text-center" style={{
          fontSize: '13px',
          color: '#777777',
          marginTop: '12px',
          marginBottom: 0
        }} data-id="element-42">
            30-Day Money Back Guarantee — Zero Risk
          </p>

          {/* Bonus previews */}
          <div className="mt-8 pt-8 border-t border-accent/60" data-id="element-43">
            <p className="font-lato font-bold uppercase text-medium text-center mb-5" style={{
            fontSize: '12px',
            letterSpacing: '0.15em'
          }} data-id="element-44">
              Plus 3 Exclusive Bonuses Included
            </p>

            <div className="grid grid-cols-3 gap-2 md:gap-3" data-id="element-45">
              {BONUS_PREVIEWS.map(bonus => <div key={bonus.number} className="bg-white rounded-[12px] p-2 md:p-3 border border-accent flex flex-col items-center text-center" style={{
              boxShadow: '0 2px 8px rgba(149,125,173,0.12)'
            }} data-id="element-46">
                  <div className="w-full overflow-hidden rounded-[8px] mb-2" style={{
                aspectRatio: '4 / 3'
              }} data-id="element-47">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-48" />
                  </div>

                  <span className="font-lato font-bold text-white mb-2" style={{
                background: '#957DAD',
                fontSize: '9px',
                padding: '3px 10px',
                borderRadius: '50px',
                letterSpacing: '0.12em',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                display: 'inline-block'
              }} data-id="element-49">
                    BONUS&nbsp;{bonus.number}
                  </span>

                  <p className="font-lato text-primary m-0 px-1" style={{
                fontSize: '11px',
                fontWeight: 700,
                lineHeight: 1.3,
                overflowWrap: 'break-word',
                hyphens: 'auto'
              }} data-id="element-50">
                    {bonus.title}
                  </p>
                </div>)}
            </div>

            <a href="#bonus-stack" className="font-lato inline-flex items-center gap-1 mt-6 group transition-colors duration-200" style={{
            color: '#957DAD',
            fontSize: '14px',
            fontWeight: 700,
            textDecoration: 'none',
            borderBottom: '1px solid #957DAD',
            paddingBottom: '2px'
          }} data-id="element-51">
              <span data-id="element-52">More Information</span>
              <span className="inline-block transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-53">
                →
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>;
};